import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';

export function getCapacityInfo(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/pricing/capacity/getcapacityinfo', config)
    .then(res => res.data);
}

export function getIntegrationAvailabilities(
  accommodationId: string,
  integrationType: 1,
  seasonRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId, integrationType, seasonRateId },
  };

  return axios
    .get('/pricing/capacity/getintegrationavailabilities', config)
    .then(res => res.data);
}

export function getIntegrationAvailabilitiesByAccommodation(
  bookingByAccommodationRequest,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/pricing/capacity/getintegrationavailabilitiesbyaccommodation',
      bookingByAccommodationRequest,
      config,
    )
    .then(res => {
      return res.data;
    });
}
